
import { RevButton } from '@ds/components/Button'
import { RevSkeleton } from '@ds/components/Skeleton'
import { IconInfo } from '@ds/icons/IconInfo'

import { STATUSES } from '../RecommendationBundle.constants'

import { VARIANTS } from './BundleAddToCart.constants'
import translations from './BundleAddToCart.translations'

export default {
  components: {
    IconInfo,
    RevButton,
    RevSkeleton,
  },

  props: {
    status: {
      type: String,
      required: true,
    },

    totalPrice: {
      type: String,
      default: null,
    },
    variant: {
      type: String,
      default: VARIANTS.DEFAULT,
    },
  },

  computed: {
    translations: () => translations,
    isCompact() {
      return this.variant === VARIANTS.COMPACT
    },
    fullWidth() {
      return this.variant === VARIANTS.COMPACT ? 'always' : ''
    },
    isFetching() {
      return this.status === STATUSES.FETCHING
    },
    isAddingToCart() {
      return this.status === STATUSES.ADDING_TO_CART
    },
    isError() {
      return this.status === STATUSES.ERROR_ADDING_TO_CART
    },
    showError() {
      return this.isError && this.isCompact
    },
  },

  methods: {
    addToCart() {
      this.$emit('add-to-cart')
    },
  },
}
